import React from "react";
import styled from "styled-components";
//import NavigationItems from "../NavigationItems/NavigationItems";
import Backdrop from "../../../UI/Backdrop/Backdrop";
//import Newsletter from "../../Newsletter/Newsletter";
//import { Link } from "react-router-dom";

const StyledSidedrawer = styled.div`
  position: fixed;
  width: 20rem;
  max-width: 70%;
  height: 100%;
  top: 6rem;
  left: 0;
  z-index: 100;
  background-color: white;
  padding: 3rem 1rem;
  box-sizing: border-box;
  transition: transform 0.3s ease-out;
  transform: translateX(${props => (props.showSideDrawer ? "0" : "-100%")});

  @media (min-width: 701px) {
    display: none;
  }
`;

const Item = styled.a`
  text-decoration: none;
  text-transform: uppercase;
  color: ${props => props.theme.colorPrimary};
  font-size: 17px;
  font-weight: 600;
  padding: 1rem 0;

  &:hover,
  &:focus {
    color: ${props => props.theme.colorGrayDark};
  }

  &:focus,
  &:hover,
  &:visited,
  &:link,
  &:active {
    text-decoration: none;
  }
`;

const StyledList = styled.ul`
  list-style-type: none;
  margin-left: 2rem;
`;

const ListItem = styled.li`
  padding-bottom: 1rem;
`;

const Sidedrawer = props => {
  return (
    <div>
      <Backdrop show={props.open} clicked={props.closed} />
      <StyledSidedrawer showSideDrawer={props.open}>
        {/*<NavigationItems />*/}
        <StyledList>
          <ListItem>
            <Item href="/vision">Vision</Item>
          </ListItem>
          <ListItem>
            <Item href="/concept">Concept</Item>
          </ListItem>
          <ListItem>
            <Item href="/progress">Progress</Item>
          </ListItem>
        </StyledList>
      </StyledSidedrawer>
    </div>
  );
};

export default Sidedrawer;



// WEBPACK FOOTER //
// ./src/components/Navgation/Sidedrawer/Sidedrawer.js